<div class="service-text">
    <div class="service-text__icon">
        <img src="../../../assets/svg-icons/toolbox-solid.svg" alt="tool-box">
    </div>
    <div class="service-text__info">
        <div class="service-text__title">
            {{"services.to1" | translate}}
        </div>
    </div>
</div>